import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  Form,
  FormElement,
  TranslationManager,
  ViewState,
  MessageSearchModel,
  MessageModalComponent,
  Auth,
  SupplierOfferMessageSendModel, SupplierOfferService, SupplierOfferMessageModel, ReadMessageModel, ReadMessagesModel, LastReadMessageModel
} from 'src/common';

@Component({
  selector: 'supplier-offer-messages',
  templateUrl: 'supplier-offer-messages.component.html'
})

export class SupplierOfferMessagesComponent implements OnInit, OnDestroy {

  @ViewChild('messageItems') private messageItems: ElementRef;
  @ViewChild("messageModal") messageModal: MessageModalComponent;

  @Input() id: number;
  @Input() state: ViewState;
  viewState = ViewState;

  form: Form = new Form();

  items: SupplierOfferMessageModel[] = [];
  translationManager = TranslationManager;
  auth = Auth;

  private lastMessageId: number = undefined;
  private lastTableName: string = undefined;
  messageInterval: any;

  constructor(private supplierOfferService: SupplierOfferService) {
  }

  ngOnInit(): void {
    this.initForm();

    this.getMessages().then(() => {
      this.scrollToBottom();
    })
    this.messageInterval = setInterval(() => { this.getMessages() }, 5000);
  }

  scrollToBottom(): void {
    setTimeout(() => {
      this.scrollMessages();
    }, 500);
  }

  scrollMessages(): void {
    try {
      this.messageItems.nativeElement.scrollTo({ left: 0, top: this.messageItems.nativeElement.scrollHeight, behavior: 'smooth' });
    } catch (err) { }
  }

  ngOnDestroy(): void {
    clearInterval(this.messageInterval);
  }

  private initForm(): void {
    this.form.elements["message"] = new FormElement();
    this.form.elements["message"].state.mandatory = true;

    this.form.elements["panelSendMessage"] = new FormElement();
    this.form.elements["panelSendMessage"].state.visible = (this.state === ViewState.Edit);
  }

  private getMessages(): Promise<void> {
    return new Promise<void>((resolve) => {
      let model: MessageSearchModel = new MessageSearchModel();

      model.fromMessageId = this.lastMessageId;
      model.tableName = this.lastTableName;

      this.supplierOfferService.getLastReadMessage(this.id).then((lastReadMessage: LastReadMessageModel) => {
        this.supplierOfferService.getMessages(this.id, model).then((items: SupplierOfferMessageModel[]) => {

          let readMessages: ReadMessagesModel = new ReadMessagesModel();
          readMessages.supplierOfferId = this.id;

          if (items && items.length > 0) {
            items.forEach(s => {
              this.lastMessageId = s.messageId;
              this.lastTableName = s.tableName;

              this.makeInitials(s);
              this.items.push(s);

              if (new Date(s.messageCreatedOn) > new Date(lastReadMessage.readTime) && s.messageFromUserId != Auth.user.id) {
                readMessages.items.push(this.mapToMessageReadModel(s));
              }
            });

            if (readMessages.items?.length > 0) {
              this.supplierOfferService.saveReadMessages(readMessages);
            }
          }
          resolve();
        })
      })
    })
  }

  private mapToMessageReadModel(item: SupplierOfferMessageModel): ReadMessageModel {
    let model: ReadMessageModel = new ReadMessageModel();
    model.messageId = item.messageId;
    model.tableName = item.tableName;

    return model;
  }

  private makeInitials(model: SupplierOfferMessageModel): void {
    if (model.messageFromUserFullName) {
      let splittedName = model.messageFromUserFullName.split(' ');

      model.messageFromUserInitials = '';

      if (splittedName.length >= 1) {
        model.messageFromUserInitials += splittedName[0].length >= 1 ? splittedName[0].charAt(0).toUpperCase() : '';
      }

      if (splittedName.length >= 2) {
        model.messageFromUserInitials += splittedName[1].length >= 1 ? splittedName[1].charAt(0).toUpperCase() : '';
      }
    }
  }

  sendMessage() {
    if (this.form.isValid()) {
      let model = new SupplierOfferMessageSendModel();
      model.messageFromUserId = Auth.user.id;
      model.messageFromUserFullName = Auth.user.firstName + ' ' + Auth.user.lastName;
      model.supplierOfferId = +this.id;
      model.message = this.form.elements["message"].value.toString();

      this.supplierOfferService.sendMessage(model).then(() => {
        this.getMessages().then(() => {
          this.scrollToBottom();
        })
        this.form.elements["message"].value = undefined;
      }).catch((error: any) => {
        this.messageModal.messages = error.error.messages;
        this.messageModal.showModal();
      });
    }
  }
}
